import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { toast } from "react-toastify";

import ConfirmDialog from "src/components/ConfirmDialog";
import { supportDeleteAccount } from "src/apiService/modules/support";
import {
  supportGetToken,
  supportIsAdmin,
} from "src/store/support/selector";

const useStyles = makeStyles((theme) => ({
  section: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  deleteButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

interface DeleteAccountSectionProps {
  username: string;
}

function DeleteAccountSection({ username }: DeleteAccountSectionProps) {
  const classes = useStyles();
  const history = useHistory();
  const token = useSelector(supportGetToken);
  const isAdmin = useSelector((state) => supportIsAdmin(state as any));
  const [open, setOpen] = useState(false);

  if (!isAdmin) return null;

  const handleConfirm = async () => {
    try {
      await supportDeleteAccount(token, username);
      toast.success("Account deleted");
      setOpen(false);
      history.push("/support/user");
    } catch (e) {
      toast.error("Could not delete account");
      throw e;
    }
  };

  return (
    <Box className={classes.section}>
      <Button
        variant="contained"
        className={classes.deleteButton}
        onClick={() => setOpen(true)}
      >
        Delete account
      </Button>
      <ConfirmDialog
        open={open}
        title="Delete account"
        text={`Permanently delete the account for "${username}"? This removes Firebase Auth, Firestore data, and the Stripe customer. This cannot be undone.`}
        cancel="Cancel"
        confirm="Delete account"
        onCancel={() => setOpen(false)}
        onConfirm={handleConfirm}
      />
    </Box>
  );
}

export default DeleteAccountSection;
